// Configuración centralizada de WhatsApp de FM Subastas.
// Cualquier cambio de número o mensaje se hace SOLO en este archivo.
// Compatible con target="_blank" bloqueado: intenta window.open y, si falla,
// hace navegación en la misma pestaña.

// Nueva línea de WhatsApp Business FM Subastas — España +34 623 799 668
export const WHATSAPP_NUMBER = "34623799668";

// Mensaje ÚNICO — actúa como activador de la programación externa del
// asistente WhatsApp Business. No debe personalizarse por página.
export const WA_DEFAULT_MSG =
  "Hola, tengo interés en obtener información sobre los servicios de FM Subastas";

// Compat: todos los alias (generic/orientacion/consultoria/premium/postsubasta)
// resuelven al MISMO mensaje único. Los archivos existentes que los importan
// siguen funcionando sin cambios y todos envían idéntico texto.
export const WA_MSG = {
  generic: WA_DEFAULT_MSG,
  orientacion: WA_DEFAULT_MSG,
  consultoria: WA_DEFAULT_MSG,
  premium: WA_DEFAULT_MSG,
  postsubasta: WA_DEFAULT_MSG,
};

export function buildWaUrl(message) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  const text = message || WA_DEFAULT_MSG;
  return `${base}?text=${encodeURIComponent(text)}`;
}

// Safe opener: intenta pestaña nueva; si el navegador la bloquea, navega en la misma.
export function openWhatsApp(message) {
  const url = buildWaUrl(message);
  try {
    const w = window.open(url, "_blank", "noopener,noreferrer");
    if (!w || w.closed || typeof w.closed === "undefined") {
      window.location.href = url;
    }
  } catch {
    window.location.href = url;
  }
}
